"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cesenatico": {
    "61adbf44": [{
      "hkey": "7b46f94a",
      "slug": "borella-villalta",
      "name": "Borella-Villalta",
      "primary": true,
      "skipSearch": false
    }],
    "borella": [{
      "hkey": "7b46f94a",
      "slug": "borella-villalta",
      "name": "Borella-Villalta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesenatico"
    }],
    "c6f1b74a": [{
      "hkey": "9c73c735",
      "slug": "levante-boschetto",
      "name": "Levante-Boschetto",
      "primary": true,
      "skipSearch": false
    }],
    "boschetto": [{
      "hkey": "9c73c735",
      "slug": "levante-boschetto",
      "name": "Levante-Boschetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesenatico"
    }],
    "f5ab9916": [{
      "hkey": "42a3ac23",
      "slug": "ponente-zadina",
      "name": "Ponente-Zadina",
      "primary": true,
      "skipSearch": false
    }],
    "ponente": [{
      "hkey": "42a3ac23",
      "slug": "ponente-zadina",
      "name": "Ponente-Zadina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesenatico"
    }],
    "65712961": [{
      "hkey": "9c73c735",
      "slug": "levante-boschetto",
      "name": "Levante-Boschetto",
      "primary": true,
      "skipSearch": false
    }],
    "rioni-levante": [{
      "hkey": "9c73c735",
      "slug": "levante-boschetto",
      "name": "Levante-Boschetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesenatico"
    }],
    "ed9ae19b": [{
      "hkey": "7b46f94a",
      "slug": "borella-villalta",
      "name": "Borella-Villalta",
      "primary": true,
      "skipSearch": false
    }],
    "villalta": [{
      "hkey": "7b46f94a",
      "slug": "borella-villalta",
      "name": "Borella-Villalta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesenatico"
    }],
    "b4ce4806": [{
      "hkey": "42a3ac23",
      "slug": "ponente-zadina",
      "name": "Ponente-Zadina",
      "primary": true,
      "skipSearch": false
    }],
    "zadina": [{
      "hkey": "42a3ac23",
      "slug": "ponente-zadina",
      "name": "Ponente-Zadina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cesenatico"
    }]
  }
};
exports["default"] = _default;